import { CloneLegalCaseState } from './partials/clone'
import { ClosingWizardState } from './partials/closing-wizard'
import { DocketEntriesInfoState } from './partials/docket-entries-info'
import { DocketEntriesState } from './partials/docket-entries'
import { ECOPortalIntegrationState } from './partials/eco-portal-integration'
import { EngagementLetterState } from './partials/engagement-letter'
import { LegalCaseEditState } from './partials/edit'
import { LegalCaseTagState } from './partials/tag'
import { ReopeningWizardState } from './partials/reopening-wizard'

export const virginLegalCase = {
  checklist: null,
  closed: null,
  docketEntries: [],
  engagement_letter: {
    language_id: null,
    notification_channel: null,
    notification_language: null,
    notification_message: null,
    recipient_identifier: null,
  },
  id: null,
  legal_case_type_id: null,
  modified_workflows: [],
  opened: null,
  other_attorney_ids: [],
  other_legal_assistant_ids: [],
  parties: [],
  primary_attorney_id: null,
  primary_legal_assistant_id: null,
  skip_workflow: false,
  tags: [],
  title: null,
}

export const LegalCaseState = _ => ({
  ...CloneLegalCaseState,
  ...ClosingWizardState,
  ...DocketEntriesInfoState,
  ...DocketEntriesState,
  ...ECOPortalIntegrationState,
  ...EngagementLetterState,
  ...LegalCaseEditState,
  ...LegalCaseTagState,
  ...ReopeningWizardState,

  currentLegalCase: { ...virginLegalCase },
  currentLegalCaseId: null,
  legalCase: { ...virginLegalCase },
  legalCases: [],
  legalCaseOptionsList: [],
  legalCaseUnassociatedParties: [],
  isSearching: false,
  paginationOptions: {
    page: 1,
    itemsPerPage: 20,
    sortBy: [],
    sortDesc: [],
  },
  partySliderSettings: {
    showRecordHolderAndContactPartyCards: true,
  },
  showAssociatePartyDialog: false,
})
